module.exports = __webpack_public_path__ + "img/ios-qr.a786ac35.png";